/*
 * Conceal PDP redesign behaviours. Loaded from sections/main-product.liquid.
 *
 * 1. Gallery nav — the mono "01 / 17" counter with square ‹ › buttons under
 *    the thumbnail rail. Arrows cycle with wrap-around by driving the Dawn
 *    thumbnail buttons, so media-gallery.js keeps owning the actual switch.
 * 2. Live add-to-cart total — "ADD TO CART — $62.32" tracks price × quantity.
 */
(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initGalleryNav(nav) {
    var gallery = nav.closest('media-gallery');
    if (!gallery) return;
    var thumbButtons = Array.prototype.slice.call(
      gallery.querySelectorAll('.thumbnail-list__item .thumbnail')
    );
    if (!thumbButtons.length) return;

    var counter = nav.querySelector('[data-conceal-gallery-counter]');
    var total = thumbButtons.length;

    function currentIndex() {
      for (var i = 0; i < thumbButtons.length; i++) {
        if (thumbButtons[i].getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    function updateCounter() {
      if (counter) counter.textContent = pad(currentIndex() + 1) + ' / ' + pad(total);
    }

    function go(delta) {
      var next = (currentIndex() + delta + total) % total;
      thumbButtons[next].click();
      var item = thumbButtons[next].closest('.thumbnail-list__item');
      if (item && item.scrollIntoView) {
        item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      // media-gallery.js sets aria-current synchronously on click.
      updateCounter();
    }

    nav.querySelector('[data-conceal-gallery-prev]').addEventListener('click', function () {
      go(-1);
    });
    nav.querySelector('[data-conceal-gallery-next]').addEventListener('click', function () {
      go(1);
    });
    // Direct thumbnail clicks and variant-driven media switches also move
    // aria-current; catch them at the gallery level after they settle.
    gallery.addEventListener('click', function () {
      window.requestAnimationFrame(updateCounter);
    });

    document.addEventListener('keydown', function (event) {
      if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      var active = document.activeElement;
      if (
        active &&
        (active.matches('input, select, textarea, button, a, [contenteditable="true"]') ||
          active.closest('dialog[open], product-modal[open], .product-media-modal[open]'))
      ) {
        return;
      }

      event.preventDefault();
      go(event.key === 'ArrowLeft' ? -1 : 1);
    });
    // Mobile swipes: media-gallery.js re-points aria-current from a debounced
    // slideChanged handler, so wait out the debounce before reading it.
    var viewer = gallery.querySelector('slider-component');
    if (viewer) {
      viewer.addEventListener('slideChanged', function () {
        window.setTimeout(updateCounter, 200);
      });
    }

    updateCounter();
  }

  function initAtcTotal(span) {
    var price = Number(span.getAttribute('data-price'));
    var currency = span.getAttribute('data-currency') || 'USD';
    if (!price) return;
    var section = span.closest('.shopify-section') || document;
    var qtyInput = section.querySelector('.quantity__input');

    var format;
    try {
      format = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
      });
    } catch (e) {
      return;
    }

    function update() {
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      span.textContent = ' — ' + format.format((price * qty) / 100);
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', update);
      var stepper = qtyInput.closest('quantity-input');
      if (stepper) {
        stepper.addEventListener('click', function () {
          window.requestAnimationFrame(update);
        });
      }
    }
    update();
  }

  function initSizeChartOpener(button) {
    button.addEventListener('click', function () {
      var section = button.closest('.shopify-section') || document;
      var opener = section.querySelector('.product-popup-modal__opener--size-chart .product-popup-modal__button');
      if (opener) opener.click();
    });
  }

  function init() {
    document.querySelectorAll('[data-conceal-gallery-nav]').forEach(initGalleryNav);
    document.querySelectorAll('.conceal-atc-total[data-price]').forEach(initAtcTotal);
    document.querySelectorAll('[data-conceal-size-chart-opener]').forEach(initSizeChartOpener);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
